import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Page404Component } from './common/ui-components/page404/page404.component';
import { AuthGuardGuard } from './Authentication/auth-guard.guard';
import { MenuLayoutComponent } from './layout/menu-layout/menu-layout.component';

const routes: Routes = [
  {
    path: 'public',
    loadChildren: () => import('./public/public.module')
      .then(m => m.PublicModule)
  },
  {
    path: '',
    component: MenuLayoutComponent,
    children: [
      // default path redirection 
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      // remove below item (login redirection code) after bazaarnear landing html page is deployed after 30 may 2024
      {
        path: 'login',
        redirectTo: 'admin/login',
        pathMatch: 'full'
      },
      {
        path: 'backoffice',
        loadChildren: () => import('./back-office-pages/back-office.module')
          .then(m => m.BackOfficeModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module')
          .then(m => m.DashboardModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin-pages/admin-pages.module')
          .then(m => m.AdminPagesModule)
      },
      {
        path: 'user',
        loadChildren: () => import('./pages/users/users.module')
          .then(m => m.UsersModule)
      },
      {
        path: 'cart',
        loadChildren: () => import('./pages/cart/cart.module')
          .then(m => m.CartModule)
      },
      {
        path: 'products',
        loadChildren: () => import('./pages/product/product.module')
          .then(m => m.ProductModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./pages/profile/profile.module')
          .then(m => m.ProfileModule)
      },
      {
        path: 'sales',
        loadChildren: () => import('./pages/sales/sales.module')
          .then(m => m.SalesModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module')
          .then(m => m.ReportsModule)
      },
      {
        path: 'Reseller',
        loadChildren: () => import('./reseller-pages/reseller-pages.module')
          .then(m => m.ResellerPagesModule)
      },
      {
        path: 'sellers',
        data: { requiredRole: 'superadmin' }, // Role-based check
        canActivate: [AuthGuardGuard],
        loadComponent: () => import('./admin-pages/seller-detail-list/seller-detail-list.component')
          .then(m => m.SellerDetailListComponent)
      },
      {
        path: 'servicenear',
        loadChildren: () => import('./third-party/service-near/service-near.module')
          .then(m => m.ServiceNearModule)
      },
      {
        path: 'secondhand',
        loadChildren: () => import('./third-party/second-hand/second-hand.module')
          .then(m => m.SecondHandModule)
      },
    ]
  },
  {
    path: '**',
    component: Page404Component,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
